/* ==========================================================================
  Hero scripts
========================================================================== */

/* global object_vars */

const initBookingForm = () => {
  const form = document.querySelector("#bookingForm");

  if (!form) {
    return;
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();

    // Get input value
    const endpoint = object_vars.bookingEndpoint;
    const city = document.querySelector("#bookingCity").value;
    const langCode = document.querySelector("#bookingLanguage").value;

    // Construct URL
    const url = `${endpoint}/${encodeURIComponent(
      city
    )}/?language=${encodeURIComponent(langCode)}`;

    // Open URL in new window
    window.open(url, "_blank");
  });
};

const initDatePickerBookingForm = () => {
  const inputDate = document.getElementById("bookingDates");

  if (!inputDate) {
    return;
  }

  const picker = new easepick.create({
    element: "#bookingDates",
    css: ["https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css"],
    zIndex: 10,
    lang: "fr-FR",
    RangePlugin: {
      tooltip: false,
    },
    format: "DD MMM",
    plugins: ["RangePlugin"],
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initBookingForm();
  initDatePickerBookingForm();
});
